import React from 'react';
import { Section, Image, Link, OnVisible } from 'components';

import * as styles from './styles.module.scss';

const CompactTwoColContentBlock = (props) => {
  const { data } = props;
  const { primary, items } = data;

  const { cta_text: ctaText, cta_link: ctaLink } = primary;

  // content checks
  const hasCta = ctaText?.text && ctaLink?.url;

  return (
    <Section sliceName="CompactTwoColContentBlock" className={styles.section} containerClassName={styles.container}>
      <div className={styles.blocks}>
        {items?.[0] &&
          items.map((item, index) => {
            const { two_col_image: itemImage, two_col_content: itemContent, two_col_title: itemTitle } = item || {};

            const titleHtml = itemTitle?.html;
            const contentHtml = itemContent?.html;
            const imageUrl = itemImage?.url;

            const isEven = index % 2 !== 0;

            return (
              <article
                key={`compact-two-col-contenct-block-${index}`}
                className={`${styles.block} ${isEven ? styles.reverse : ''}`}
              >
                <OnVisible visibleClassName={styles.visible} className={styles.blockContent}>
                  {titleHtml && <div dangerouslySetInnerHTML={{ __html: titleHtml }} className={styles.title} />}
                  {contentHtml && (
                    <div className={styles.textContent} dangerouslySetInnerHTML={{ __html: contentHtml }} />
                  )}
                </OnVisible>

                {imageUrl && (
                  <OnVisible visibleClassName={styles.visible} className={styles.blockImage} threshold="0.4">
                    <Image image={itemImage} />
                  </OnVisible>
                )}
              </article>
            );
          })}
      </div>

      {hasCta && (
        <Link className={`button ${styles.cta}`} to={ctaLink?.url}>
          {ctaText?.text}
        </Link>
      )}
    </Section>
  );
};

export default CompactTwoColContentBlock;
